import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { unwrap34f7x4f5snsxt as unwrap } from '../internal/StackTraceRecovery.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Key_instancepi2bbb0csu5f as Key_instance } from '../Job.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { add2suhfggl4zvkk as add } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function catch_0(_this__u8e3s4, action) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (catch$$inlined$unsafeFlow$1())(_this__u8e3s4, action);
}
function *catchImpl(_this__u8e3s4, collector, $completion) {
  var fromDownstream = {_v: null};
  try {
    var tmp = catchImpl$slambda(collector, fromDownstream);
    yield* _this__u8e3s4.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      var fromDownstream_0 = fromDownstream._v;
      var tmp_0;
      if (isSameExceptionAs(e, fromDownstream_0)) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.get_context_h02k06_k$();
        tmp_0 = isCancellationCause(e, tmp$ret$0);
      }
      if (tmp_0) {
        throw e;
      } else {
        if (fromDownstream_0 == null) {
          return e;
        }
        if (e instanceof CancellationException()) {
          addSuppressed(fromDownstream_0, e);
          throw fromDownstream_0;
        } else {
          addSuppressed(e, fromDownstream_0);
          throw e;
        }
      }
    } else {
      throw $p;
    }
  }
  return null;
}
function isSameExceptionAs(_this__u8e3s4, other) {
  return !(other == null) && equals(unwrap(other), unwrap(_this__u8e3s4));
}
function isCancellationCause(_this__u8e3s4, coroutineContext) {
  var job = coroutineContext.get_y2st91_k$(Key_instance);
  if (job == null || !job.get_isCancelled_trk8pu_k$())
    return false;
  return isSameExceptionAs(_this__u8e3s4, job.getCancellationException_8i1q6u_k$());
}
function retryWhen(_this__u8e3s4, predicate) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (retryWhen$$inlined$unsafeFlow$1())(_this__u8e3s4, predicate);
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var catch$$inlined$unsafeFlow$1Class;
function catch$$inlined$unsafeFlow$1() {
  if (catch$$inlined$unsafeFlow$1Class === VOID) {
    class $_0 {
      constructor($this_catch, $action) {
        this.$this_catch_1 = $this_catch;
        this.$action_1 = $action;
      }
      *collect_ooju95_k$(collector, $completion) {
        var exception = yield* /*#__NOINLINE__*/catchImpl(this.$this_catch_1, collector, $completion);
        if (!(exception == null))
          yield* $(this.$action_1(collector, exception, $completion), $completion);
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($_0, VOID, VOID, VOID, VOID, [1]);
    catch$$inlined$unsafeFlow$1Class = $_0;
  }
  return catch$$inlined$unsafeFlow$1Class;
}
function catchImpl$slambda($collector, $fromDownstream) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    try {
      tmp = yield* $collector.emit_t92u1f_k$(it, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        $fromDownstream._v = e;
        throw e;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 1);
}
var retryWhen$$inlined$unsafeFlow$1Class;
function retryWhen$$inlined$unsafeFlow$1() {
  if (retryWhen$$inlined$unsafeFlow$1Class === VOID) {
    class $_0 {
      constructor($this_retryWhen, $predicate) {
        this.$this_retryWhen_1 = $this_retryWhen;
        this.$predicate_1 = $predicate;
      }
      *collect_ooju95_k$(collector, $completion) {
        var attempt = 0n;
        var shallRetry;
        do {
          shallRetry = false;
          var cause = yield* /*#__NOINLINE__*/catchImpl(this.$this_retryWhen_1, collector, $completion);
          if (!(cause == null)) {
            if (yield* $(this.$predicate_1(collector, cause, attempt, $completion), $completion)) {
              shallRetry = true;
              var _unary__edvuaz = attempt;
              attempt = add(_unary__edvuaz, get_ONE());
            } else {
              throw cause;
            }
          }
        }
         while (shallRetry);
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($_0, VOID, VOID, VOID, VOID, [1]);
    retryWhen$$inlined$unsafeFlow$1Class = $_0;
  }
  return retryWhen$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  catch_0 as catchrcnx5mlu3pkp,
  retryWhen as retryWhenf2aqzvtrvxoo,
};
//endregion

//# sourceMappingURL=Errors.mjs.map
